<template>
  <div>
    <div
      class="box text-center"
      :class="box.destaque ? 'box-destaque' : ''"
      @click="redirecionaCaixa(box)"
    >
      <div
        class="d-grid iconTipoCaixa"
        v-if="
          box.destaque ||
            box.descontoProgressivo ||
            box.ofertaRelampago ||
            box.ofertaExclusivaPrime ||
            box.compraRecorrenteComMaisDesconto
        "
      >
        <div class="d-flex" v-if="box.ofertaRelampago">
          <el-tooltip class="item" content="Oferta Relâmpago" placement="top">
            <img class="iconbox mb-1" src="@/assets/relampago.png" />
          </el-tooltip>
        </div>
        <div class="d-flex" v-if="box.destaque">
          <el-tooltip class="item" content="Destaque" placement="top">
            <img class="iconbox mb-1" src="@/assets/fire.png"
          /></el-tooltip>
        </div>
        <div class="d-flex" v-if="box.descontoProgressivo">
          <el-tooltip
            class="item"
            content="Desconto Progressivo"
            placement="top"
          >
            <img class="iconbox mb-1" src="@/assets/desconto.png"
          /></el-tooltip>
        </div>
        <div class="d-flex" v-if="box.ofertaExclusivaPrime">
          <el-tooltip
            class="item"
            content="Oferta Exclusiva para Clientes Prime"
            placement="top"
          >
            <img class="iconbox mb-1" src="@/assets/exclusivo-prime.png"
          /></el-tooltip>
        </div>
        <div class="d-flex" v-if="box.compraRecorrenteComMaisDesconto">
          <el-tooltip
            class="item"
            content="Mais descontos com a Compra Recorrente"
            placement="top"
          >
            <img class="iconbox mb-1" src="@/assets/recorrente.png"
          /></el-tooltip>
        </div>
      </div>
      <div class="time text-left">há {{ diferencaHoras(box.createdAt) }}</div>
      <div class="d-flex nomeCaixa">
        <span class=" text-left mt-1 text-uppercase">{{
          box.nomeProduto
        }}</span>
      </div>

      <div class="content-image">
        <img
          :src="box.imagem"
          class="productImage"
          loading="lazy"
          :title="box.nomeProduto"
          :alt="box.nomeProduto"
        />
        <botaoDetalhe altura="20px"> </botaoDetalhe>
      </div>
      <div class="fretes">
        <span class="badge text-dark mr-2" v-if="box.freteGratis"
          >Frete Grátis</span
        >
        <span class="badge text-dark  mr-2" v-if="box.freteGratisPrime"
          >Frete Prime</span
        >
        <span class="badge text-dark  mr-2" v-if="box.freteGratisRetirada"
          >Retire na Loja, sem frete</span
        >
      </div>
      <div class="botoes">
        <div class="text-center col-valor-old">
          <span class="badge-valor-old">
            de: {{ box.valorOld | currency }}
          </span>
        </div>
        <div class="text-center col-valor">
          <span class="badge-valor"> por: {{ box.valor | currency }} </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import botaoDetalhe from './botao-detalhe.vue';
import { Badge } from '@/components';
import moment from 'moment';
import { Tooltip } from 'element-ui';
import storage from '../../services/storage';
export default {
  props: ['box'],
  components: { botaoDetalhe, Badge, [Tooltip.name]: Tooltip },
  methods: {
    redirecionaCaixa(promo) {
      storage.escreveStorage('pr', JSON.stringify(promo));
      this.$router.push(`/p/${encodeURIComponent(promo.url)}`);
    },
    diferencaHoras(diahora) {
      const now = moment(new Date()); //todays date
      const end = moment(diahora); // another date
      const duration = moment.duration(now.diff(end));
      let horas = duration.asHours();
      let dias = duration.asDays();
      return horas < 24 ? +Math.round(horas) + 'h' : Math.round(dias) + ' dias';
    },
  },
};
</script>
<style lang="scss" scoped>
.box {
  color: #000;
  border-radius: 10px;
  padding: 10px;
  background-color: white;
  filter: drop-shadow(0px 0px 5px #0000001a);
  /*min-width: 250px;
  max-width: 250px;*/
  min-height: 340px;
  transition: background-color 0.5s ease;
  position: relative;

  .time {
    font-size: 0.4erm;
  }
  .nomeCaixa {
    font-size: 12px;
    font-weight: bold;
    height: 44px;
    display: flex;
    span {
      display: inline;
      -webkit-line-clamp: 2;
      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      word-wrap: break-word; /* Important for long words! */
    }
  }

  .fretes {
    height: 30px;
  }
  .categoriasBox {
    color: #a7a7ff;
  }

  .content-image {
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
    .productImage {
      width: 100%;
      max-width: 200px;
      max-height: 200px;
      width: auto;
      margin-top: 4px;
      margin-bottom: 4px;
    }
  }

  .badge-valor,
  .badge-valor-old {
    font-size: 1.6em;
    border-radius: 0rem;
    margin: 5px;
    line-height: 1.625rem !important;
    border: 0;
    transition: background-color 0.5s ease;
    font-weight: bold;
  }

  .badge-valor-old {
    font-size: 0.9em;
    text-decoration: line-through;
    font-weight: normal;
    padding-top: 8px !important;
  }

  .botoes {
    display: flex;
    margin: 0 0 0 5px;
    justify-content: center;
    align-items: center;
  }

  .btn {
    transition: background-image 0.5s ease;
    margin: 0px;
  }
  .iconTipoCaixa {
    display: block;
    position: absolute;
    width: 32px !important;
    margin-left: 2px;
    top: 70px;

    .iconItem {
      width: 80% !important;
      margin-left: 5px;
    }
  }
  .detalhe {
    visibility: hidden;
  }
}

.box:hover {
  .detalhe {
    visibility: visible;
  }
}

.em-breve {
  opacity: 50%;
  img {
    filter: grayscale(1);
  }
}

.productImage,
.textosBoxes {
  transition: transform 0.5s ease;
}
.box:hover {
  .productImage {
    transform: scale(1.1) !important;
    //margin-left: -30px;
  }
  .textosBoxes {
    //transform: scale(1.02);
    //transform: scale(1.02) translate(-2%, -2%);
  }
}

@media all and (min-width: 1024px) {
  .box {
    h4 {
      font-size: 16px;
    }
    img {
      width: 250px;
    }
    button {
      padding-top: 10px;
    }
  }
}

@media all and (min-width: 768px) and (max-width: 1600px) {
  .box {
    button {
      span {
        width: 100%;
        margin-top: 10px;
      }
    }
  }
}
@media (max-width: 766px) {
  .box {
    .productImage {
      max-width: 100% !important;
    }
    .botoes {
      display: block !important;
    }
    .nomeCaixa {
      height: 40px;
    }
  }
}
</style>
